import React from 'react';
import { findChildByType } from '@/components/ui/ui.utils';
import Tooltip from './Tooltip';

interface TCITooltipProps {
  theme?: 'white' | null;
  delayDuration?: number;
  side?: 'top' | 'right' | 'bottom' | 'left';
  sideOffset?: number;
  disabled?: boolean;
  showArrow?: boolean;
  children: ReactChildren;
}

const TCITooltipComponent = React.forwardRef<
  React.ElementRef<typeof Tooltip.Trigger>,
  TCITooltipProps
>(({
  theme = 'white',
  delayDuration = 0,
  side = 'top',
  sideOffset = 4,
  disabled = false,
  showArrow = true,
  children,
}, ref) => {
  const contentChild = findChildByType(children, Tooltip.Content);
  const triggerChild = findChildByType(children, Tooltip.Trigger);

  if (!contentChild || !triggerChild) {
    throw new Error('TCITooltip must have both Tooltip.Content and Tooltip.Trigger children');
  }

  return (
    <Tooltip.Provider>
      <Tooltip delayDuration={delayDuration}>
        <Tooltip.Trigger ref={ref} {...triggerChild.props}>
          {triggerChild.props.children}
        </Tooltip.Trigger>
        <Tooltip.Content
          disabled={disabled}
          side={side}
          sideOffset={sideOffset}
          theme={theme}
        >
          {showArrow && <Tooltip.Arrow theme={theme} />}
          {(contentChild as React.ReactElement).props.children}
        </Tooltip.Content>
      </Tooltip>
    </Tooltip.Provider>
  );
});

const TCITooltip = Object.assign(TCITooltipComponent, {
  Content: Tooltip.Content,
  Trigger: Tooltip.Trigger,
});

export default TCITooltip;
